<script lang="ts">
	import { Verbiage, t } from '@infinitro/content';
	import { parseInlineBoldSegments } from '../parse-inline-bold-segments';
	import { isSupportChatMediaUrl } from '../utils/support-chat-media-url';
	import type { SupportChatMessageAttachment } from '../types';

	export let text = '';
	export let attachments: SupportChatMessageAttachment[] = [];

	$: mediaUrl = !attachments.length && isSupportChatMediaUrl(text) ? text.trim() : null;
	$: plainText = mediaUrl ? '' : text;
	$: showText = Boolean(plainText.trim());
</script>

{#if mediaUrl}
	<img class="bubble-media" src={mediaUrl} alt={$t(Verbiage.message_icon_alt, 'alts')} />
{:else if showText}
	{#each parseInlineBoldSegments(plainText) as seg, i (i)}
		{#if seg.bold}
			<strong class="bubble-inline-strong">{seg.text}</strong>
		{:else}
			{seg.text}
		{/if}
	{/each}
{/if}

{#each attachments as attachment (attachment.url)}
	<img
		class="bubble-media"
		class:bubble-media-stacked={showText || mediaUrl}
		src={attachment.url}
		alt={attachment.filename || $t(Verbiage.message_icon_alt, 'alts')}
	/>
{/each}

<style>
	.bubble-inline-strong {
		font-weight: 600;
	}

	.bubble-media {
		display: block;
		max-height: 12rem;
		max-width: 100%;
		border-radius: 12px;
		-o-object-fit: contain;
		   object-fit: contain;
}

	.bubble-media-stacked {
		margin-top: 0.5rem;
}
</style>
